import { t } from '@exam-prep/i18n';

const IST = 'Asia/Kolkata';

export const when = (iso: string | null): string =>
  iso
    ? new Intl.DateTimeFormat('en-IN', {
        timeZone: IST,
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        hour: 'numeric',
        minute: '2-digit',
      }).format(new Date(iso))
    : t('common.not_set');

/** `12 Oct 2027`: the IST date a pass ends. */
export const dayIst = (iso: string): string =>
  new Intl.DateTimeFormat('en-IN', {
    timeZone: IST,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso));

/** `9 Mar 2027, 11:59 pm IST`: a fixed end date (offers), never a countdown. */
export const untilIst = (iso: string): string =>
  `${new Intl.DateTimeFormat('en-IN', {
    timeZone: IST,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso))} IST`;
